import { configureStore } from '@reduxjs/toolkit'

import userReducer from './user/userSlice'
import settingReducer from './setting/settingslice'


const rootReducer = {
  user: userReducer,
  settings: settingReducer
}

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV === 'development'
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export default store
